import cx from "classix"
import React from "react"
const SpinnerIcon = ({ className = undefined } : { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" className={cx("animate-spin", className)}>
        <path d="M10 1v2a7 7 0 1 1-7 7H1a9 9 0 1 0 9-9Z" />
    </svg>
)


export default SpinnerIcon
